<template>
  <a
    :href="editLink"
    title="Edit"
    target="_blank"
    rel="noopener"
  >
    <feather-icon
      icon="EditIcon"
      class="cursor-pointer"
      color="black"
    />
  </a>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    editComponent: {
      type: String,
      default: () => '',
    },
    type: {
      type: String,
      default: () => 'page',
    },
  },

  computed: {
    editLink() {
      const { id, name, title } = this.data.item
      let formattedName = ''

      if (typeof name === 'object' && name?.en) {
        formattedName = name.en
      } else if (typeof name === 'string') {
        formattedName = name
      }

      const params = {
        id,
        name: formattedName,
        ...(title ? { title } : {}),
      }

      if (this.type === 'page') {
        return this.$router.resolve({
          name: this.editComponent,
          params,
        }).href
      }

      return '#'
    },
  },
}
</script>
